import React from 'react'
import PropTypes from 'prop-types'
import { Nav, NavItem } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import { UIStore } from '../../stores'

const menuToggleClass = 'nav-link d-flex menu-toggle'
const menuToggleActiveClass = 'nav-link d-flex menu-toggle is-active'

@inject('uiStore')
@observer
class SidebarToggle extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.toggleSidebar = this.toggleSidebar.bind(this, 'sidebarCollapsed')

    this.state = {
      sidebarCollapsed: true
    }
  }

  toggleSidebar (key) {
    const newState = {}
    newState[key] = !this.state[key]
    this.setState(newState)
    this.props.uiStore.toggleSidebar()
  }

  render () {
    return (
      <Nav className='navbar-sidebar-toggle' aria-label='toggle'>
        <NavItem>
          <a
            className={this.props.uiStore.sidebarIsOpen ? menuToggleClass : menuToggleActiveClass}
            tabIndex='0'
            onClick={this.toggleSidebar}
            role='button'
            aria-label='Sidebar menu toggle'
            aria-expanded={this.state.sidebarCollapsed}
          >
            <svg className='icon' aria-hidden='true'>
              <title>Toggle menu</title>
              <use xlinkHref='#arrows_long_left' href='#arrows_long_left' />
            </svg>
            <div>Menu</div>
          </a>
        </NavItem>
      </Nav>
    )
  }
}

SidebarToggle.propTypes = {
  uiStore: PropTypes.instanceOf(UIStore)
}

export { SidebarToggle }
